var instantsearch;

var getUrl          = window.location;
var baseUrl         = getUrl.protocol + "//" + getUrl.host + "/"+getUrl.pathname.split('/')[1];

window.addEventListener('load', function () {
    var _o = document.querySelector('#search-box');
    var _h = document.querySelector('#search-hits');
    if (_o != null && _h != null) {
        var search = instantsearch({ appId: _o.getAttribute('data-appId'), apiKey: _o.getAttribute('data-appKey'), indexName: _o.getAttribute('data-appIndex')});
        search.addWidget(instantsearch.widgets.searchBox({ container: '#search-box', placeholder: 'Search for products', autofocus: false  }));
        search.addWidget(instantsearch.widgets.hits({ container: '#search-hits', templates: { empty: 'No results', item: function (data) {
            return sherfiReturnSearchWidget(data);
        }}}));
        search.start();
        _h.style.display = 'none';
        var _container = document.querySelector('[sh-component=index-wiki]');
        //
        _o.addEventListener('blur', function () {
            if (_h.querySelector(':hover')) return;
            _h.style.display = 'none';
            if(_container != null) _container.style.zIndex = 1 ;
        });
        _o.addEventListener('keyup', function () {
            _h.style.display = 'block';
            if(_container != null) _container.style.zIndex = 8 ;
        });

        _o.addEventListener('focus', function () {
            _h.style.display = 'block';
            if(_container != null) _container.style.zIndex = 8 ;
        });
    }
    var _oPsy = document.querySelector('#search-box-psy');
    var _hPsy = document.querySelector('#search-hits-psy-container');
    if (_oPsy != null && _hPsy != null) {
        var searchPsy = instantsearch({ appId: _oPsy.getAttribute('data-appId'), apiKey: _oPsy.getAttribute('data-appKey'), indexName: _oPsy.getAttribute('data-appIndex')});
        searchPsy.addWidget(instantsearch.widgets.searchBox({ container: '#search-box-psy', placeholder: 'Search for products', autofocus: false  }));
        searchPsy.addWidget(instantsearch.widgets.hits({ container: '#search-hits-psy', templates: { empty: '<p>Aucun résultat</p>', item: function (data) {
            return sherfiReturnSearchWidgetPsys(data);
        }}}));
        searchPsy.start();
        _hPsy.style.display = 'none';
        //
        _oPsy.addEventListener('blur', function () {
            if (_hPsy.querySelector(':hover')) return;
            _hPsy.style.display = 'none';
        });
        _oPsy.addEventListener('keyup', function () {

            if(document.querySelector('#search-box-psy').value.length >= 2) {
                _hPsy.style.display = 'block';
            }
            else {
                _hPsy.style.display = 'none';
            }

        });

    }
});

function sherfiReturnSearchWidget(data) {
    var testReg = new RegExp('\/viewer\/', 'g');
    var sLang = 'fr';



    if (data.uri.match(testReg)) {
        data.uri = data.uri.replace(testReg, '\/' + sLang + '\/viewer\/');
        data.uri += '" target="_blank';
    }

    var $__viewbox = '0 0 24 30';
    var $__path = 'M18.4,7.4l-3.8-3.8C14.2,3.2,13.7,3,13.2,3H8C6.3,3,5,4.3,5,6v12c0,1.7,1.3,3,3,3h8c1.7,0,3-1.3,3-3V8.8 C19,8.3,18.8,7.8,18.4,7.4z M14,4.4L17.6,8H15c-0.6,0-1-0.4-1-1V4.4z M18,18c0,1.1-0.9,2-2,2H8c-1.1,0-2-0.9-2-2V6c0-1.1,0.9-2,2-2 h5v3c0,1.1,0.9,2,2,2h3V18z M15.5,12h-7C8.2,12,8,11.8,8,11.5S8.2,11,8.5,11h7c0.3,0,0.5,0.2,0.5,0.5S15.8,12,15.5,12z M15.5,15h-7 C8.2,15,8,14.8,8,14.5S8.2,14,8.5,14h7c0.3,0,0.5,0.2,0.5,0.5S15.8,15,15.5,15z M15.5,18h-7C8.2,18,8,17.8,8,17.5S8.2,17,8.5,17h7 c0.3,0,0.5,0.2,0.5,0.5S15.8,18,15.5,18z';

    switch (data.type) {
        case 'user' :

            $__viewbox = '0 0 100 125';
            $__path = 'M10,87.9c0-6.6,5.1-13.7,11.4-15.9c0,0,20.1-5.8,20.1-11.4c0-2.9-5.4-8.2-5.4-8.2 c-4.1-4.8-7.2-13.7-6.3-20c0,0-1.3-22.5,20.2-22.5s20.3,22.9,20.3,22.9c0.7,6.3-2.2,15.1-6.4,19.9c0,0-5.3,5.1-5.3,7.9 c0,5.7,20.1,11.4,20.1,11.4C84.9,74.2,90,81.3,90,87.9V90H10V87.9z';

            break;

        case 'category' :

            $__viewbox = '0 0 100 125';
            $__path = 'M51.5,4.6c-0.8-0.9-2-1.3-3.2-1.2l-36.1,3c-1.8,0.2-3.3,1.5-3.6,3.3l-5,35.9c-0.2,1.2,0.2,2.4,1.1,3.3l42,44.4 c4.1,4.3,10.9,4.5,15.3,0.4c0,0,0,0,0,0l31.1-29.5c4.3-4.1,4.5-10.9,0.4-15.2L51.5,4.6z M37.6,36.8c-3.9,3.7-10,3.5-13.7-0.4 s-3.5-10,0.4-13.7s10-3.5,13.7,0.4c0,0,0,0,0,0l0,0C41.7,27,41.6,33.1,37.6,36.8c0.1,0,0,0.1,0,0.1V36.8z';

            break;

    }
    return '<div class="__co__"><div class="__ic__"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="' + $__viewbox + '" style="enable-background:new ' + $__viewbox + '" xml:space="preserve"><path d="' + $__path + '" /></svg></div><div class="__ac__"><a class="lambda" href="' + data.uri + '">' + data._highlightResult.title.value + '</a></div></div>';
}

function sherfiReturnSearchWidgetPsys(data) {
    var testReg = new RegExp('\/viewer\/', 'g');
    var sLang = 'fr';
    var sgv_search = document.querySelector('.ais-search-box--magnifier-wrapper');

    if(document.querySelector('#search-box-psy').value.length <= 0) {
        sgv_search.style.display = 'flex';
    }
    else {
        sgv_search.style.display = 'none';
    }

    if(document.querySelector('#search-box-psy').value.length < 2) {
        return;
    }


    return '<div class="__co__"><div class="__ac__"><a class="lambda" href="' + baseUrl + '/praticien/' + data.referer + '">' + data._highlightResult.office_name.value + '</a></div></div>';
}

